import { Lock } from 'lucide-react';
import { Modal } from '@/components/ui';
import { useTranslation } from '@parentpath/i18n';

interface NameLimitPaywallProps {
  isOpen: boolean;
  onClose: () => void;
  /** heute bereits bewertete Namen (used_today) */
  swipesUsed: number;
  /** resets_at aus get_swipe_status (Migration 160), ISO-Timestamp */
  resetsAt: string | null;
  onUpgrade: () => void;
}

export function NameLimitPaywall({
  isOpen,
  onClose,
  swipesUsed,
  resetsAt,
  onUpgrade,
}: NameLimitPaywallProps) {
  const { t, i18n } = useTranslation('names');

  // resets_at kommt als timestamptz und steht bereits fuer die naechste
  // lokale Mitternacht des Nutzers. Die Formatierung erfolgt in der
  // Zeitzone des Geraets, damit Datum und Uhrzeit zur Anzeige passen.
  const reset = resetsAt ? new Date(resetsAt) : null;
  const resetIsValid = reset !== null && !Number.isNaN(reset.getTime());

  const resetInfo = resetIsValid
    ? t('paywall.resetInfo', {
        date: reset.toLocaleDateString(i18n.language, {
          day: '2-digit',
          month: '2-digit',
          year: 'numeric',
        }),
        time: reset.toLocaleTimeString(i18n.language, {
          hour: '2-digit',
          minute: '2-digit',
        }),
      })
    : null;

  return (
    <Modal isOpen={isOpen} onClose={onClose} variant="sheet" title={t('paywall.title')}>
      <div className="bottom-sheet-content text-center py-6">
        <div className="w-16 h-16 bg-white/10 rounded-full flex items-center justify-center mx-auto mb-4">
          <Lock className="w-8 h-8 text-pp-orange" />
        </div>

        {/* Verbrauch - nur mit bekanntem Serverstand, sonst stuende hier
            eine Null */}
        {swipesUsed > 0 && (
          <p className="text-white/60 mb-2">
            {t('paywall.description', { count: swipesUsed })}
          </p>
        )}

        {resetInfo && <p className="text-sm text-white/50">{resetInfo}</p>}
      </div>

      <div className="bottom-sheet-footer">
        <button
          onClick={onUpgrade}
          className="w-full py-3 bg-pp-orange text-white font-medium rounded-xl text-center hover:bg-pp-orange/90 transition-colors"
        >
          {t('paywall.upgradeButton')}
        </button>
      </div>
    </Modal>
  );
}
